__turbopack_context__.v({
  "description": "legal-information-module__IF6Yba__description",
  "legal": "legal-information-module__IF6Yba__legal",
  "title": "legal-information-module__IF6Yba__title",
});
